import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";

// Action Types
export const DELETE_EVENT_SUCCESS = "DELETE_EVENT_SUCCESS";
export const DELETE_EVENT_ERROR = "DELETE_EVENT_ERROR";

// Thunk Action Creator
export const deleteEventAction = createAsyncThunk(
    "api/Calendar/deleteEvent",
    async (json, { dispatch }) => {

        try {
            const response = await axios.post(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Calendar/deleteEvent`,
                {
                    Type: json.type,
                    CalendarId: json.calendarId,
                    EventId: json.eventId
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )

            if (response.status === 200) {
                if (response.data === '') {
                    throw new Error("Problem adding an event. Logging the user out");
                } else {
                    dispatch({
                        type: DELETE_EVENT_SUCCESS,
                        payload: response.data,
                    });
                }
            }
        }
        catch (error) {
            dispatch({ type: DELETE_EVENT_ERROR, payload: error });
            //await signOut();
        }
    }
);
